module.exports = __webpack_public_path__ + "img/all.b7bb11f3.jpg";